export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SingleProduct.vue?vue&type=template&id=85af4bfa"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleProduct.vue?vue&type=template&id=85af4bfa
// module id = 94
// module chunks = 0